import auth from "../../middlewares/auth";
export const settingsPointRoute = [
  {
    path: '/settings/point',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/point/PointList'),
    name: 'settings_point',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/point/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/point/PointForm'),
    name: 'settings_point_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/point/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/point/PointForm'),
    name: 'settings_point_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];